import React from "react"
import QuestionPage from "../../templates/seo-collection/QuestionPage"

const Page = () => <QuestionPage destinationKey="paris" questionKey="palaceOrMansion" locale="fr" />

export default Page
